/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsChannelLimitResponseDto>>;
export function request(
  params: API.tms.logisticsChannelLimit.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsChannelLimit/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
